export Form from './Form';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/components/index.js